//import Libraries
import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

//import Components
import { Modal, Button } from 'reactstrap';
import Language from '../../language/language.json';
import Icons from '../../assets/icons/icons';

//import Style classes
import './SimpleModal.css'

const logoIcon = Icons.logo

const simpleModal = ({modal, toggle, onClosed, title, content, buttonValue}) => {
    return (
        <div>
            <Modal
                isOpen={modal}
                toggle={toggle}
                onClosed={onClosed}
            >
                <div className="ModalContainer">
                    <div className="Logo">{logoIcon}</div>
                    <div className="Title">
                        {title}
                    </div>
                    <form>
                        <div className="content">
                            <div className="element">
                                { content }
                            </div>
                            <div className="element">
                                <Button
                                    size="lg"
                                    color="info"
                                    className="btn"
                                    onClick={toggle}
                                >
                                    {buttonValue}
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>
        </div>
    );
}

export default simpleModal;



// WEBPACK FOOTER //
// ./src/components/SimpleModal/SimpleModal.js